import "./styles/tokens.css";
import "./App.css";
import "./styles/primitives.css";
// Buttons, dropdown arrows and focus rings for every page. After primitives so
// its tokens are available, before the page sheets that read them.
import "./styles/controls.css";
import "./styles/shared-surfaces.css";
import "./styles/shared-modals.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-medium-image-zoom/dist/styles.css";
import "./styles/swalTheme.css";
import "./styles/toast.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import Routing from "./components/Routing/Routing";
import ErrorBoundary from "./components/errorBoundary/ErrorBoundary";
import { queryClient } from "./queryClient";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="main-app-container flex-box">
        <Toaster
          // Bottom-right, the design kit's place for results; toast.css lifts
          // it above the phone dock.
          position="bottom-right"
          containerClassName="app-toaster"
          // react-hot-toast defaults its container to z-index 9999 — the exact
          // value PopUpContainer's overlay uses. On a tie the later element in
          // the DOM wins, and PopUpContainer portals to document.body AFTER
          // #root, so every toast raised from inside a modal (save
          // confirmations, validation errors, "copied to clipboard") was
          // painted behind it and never seen. 20001 clears both the modal and
          // SweetAlert's 20000.
          containerStyle={{ zIndex: 20001 }}
          // className, NOT style: the library applies `style` inline, which
          // beats every class selector and made the toast unstylable from CSS.
          // The look lives in styles/toast.css.
          toastOptions={{
            duration: 4000,
            className: "app-toast",
            /**
             * iconTheme.secondary is the TICK or CROSS drawn inside the
             * coloured disc, not the disc itself. It was #0d0502 — a
             * near-black mark on a saturated green or red circle, which is
             * the one thing on the toast that has to read at a glance. White
             * against both, matching the light-on-dark panel around it.
             */
            success: {
              className: "app-toast is-success",
              iconTheme: { primary: "var(--color-success)", secondary: "#ffffff" },
            },
            error: {
              // Red, not the brand orange this app used to use here — an error
              // toast drawn in the accent colour reads as neutral chrome.
              className: "app-toast is-error",
              iconTheme: { primary: "var(--color-danger)", secondary: "#ffffff" },
              // An error must be read, not raced: it stays twice as long as a
              // success (NN/g, Atlassian flags).
              duration: 8000,
            },
          }}
        />
        {/* Outermost backstop: an uncaught render error anywhere in the app
            would otherwise unmount everything to a blank white page. */}
        {/**
         * THE PAGE'S CONTENT, named as such.
         *
         * Without a landmark a screen reader has no way past the sidebar and
         * the header to the thing the seller came for -- it reads the whole
         * navigation on every single page. One <main> here covers all 29
         * routes; one per page would be 29 chances to forget, and two nested
         * would be worse than none.
         */}
        <main id="main-content" className="app-main">
          <ErrorBoundary
            message="Something went wrong while displaying this page. Reloading usually fixes it."
            retryLabel="Reload"
            onReset={() => window.location.reload()}
          >
            <Routing />
          </ErrorBoundary>
        </main>
      </div>
    </QueryClientProvider>
  );
}

export default App;
// app
